<template>
  <div class="wrapper"
       :class="{
         'bg-green-50': type === 'success',
         'bg-red-50': type === 'error',
         'bg-yellow-50': type === 'warning',
         'bg-blue-50': type === 'info',
       }"
       v-if="visible">
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon class="h-5 w-5 text-green-400"
                         v-if="type === 'success'"
                         aria-hidden="true" />
        <ExclamationCircleIcon class="h-5 w-5 text-red-400"
                               v-if="['error', 'warning'].includes(type)"
                               aria-hidden="true" />
      </div>
      <div class="ml-3">
        <p class="text-sm font-medium"
           :class="{
             'text-green-800': type === 'success',
             'text-red-800': type === 'error',
             'text-warning-800': type === 'warning',
             'text-blue-800': type === 'info',
           }">
          {{ message }}
        </p>
      </div>
      <div class="ml-auto pl-3">
        <div class="-mx-1.5 -my-1.5">
          <button type="button"
                  class="inline-flex rounded-md p-1.5 focus:outline-none focus:ring-2 focus:ring-offset-2"
                  :class="{
                    'bg-green-50 text-green-500 hover:bg-green-100 focus:ring-offset-green-50 focus:ring-green-600': type === 'success',
                    'bg-red-50 text-red-500 hover:bg-red-100 focus:ring-offset-red-50 focus:ring-red-600': type === 'error'
                  }"
                  @click="visible = false">
            <span class="sr-only">Dismiss</span>
            <XIcon class="h-5 w-5" aria-hidden="true" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CheckCircleIcon,
  XIcon,
  ExclamationCircleIcon,
} from '@heroicons/vue/solid'

const supportedTypes = ['success', 'error', 'warning', 'info']

export default {
  components: {
    CheckCircleIcon,
    ExclamationCircleIcon,
    XIcon,
  },

  props: {
    type: {
      type: String,
      default: 'success',
      validator(value) {
        return supportedTypes.includes(value)
      }
    },
    message: String,
  },

  data() {
    return {
      visible: true,
    }
  }
}
</script>

<style scoped>
.wrapper {
  @apply rounded-md p-4 my-4;
}
</style>
